module.exports = __webpack_public_path__ + "static/media/sweeping.064cb5ba.ogg";